import {
  shared,
  TenantConfig,
  BarcoConfig,
} from '@tig-dpqa-cloud/contract-backend-common';
import { z } from 'zod';

export const TenantsPostResponse = z.object({
  tenantId: shared.TenantId,
});
export type TenantsPostResponseType = z.infer<typeof TenantsPostResponse>;

export const TenantGetResponse = z.object({
  id: shared.TenantId,
  displayName: z.string().optional(),
  customerName: z.string(),
  tenantConfig: TenantConfig.optional(),
  barcoConfig: BarcoConfig,
  configState: shared.configState,
  metadataConfigRef: z.string().optional(),
  createdAt: z.date().transform((d) => d.toISOString()),
  updatedAt: z.date().transform((d) => d.toISOString()),
});

export type TenantGetResponseType = z.infer<typeof TenantGetResponse>;

export const TenantCreateBody = z.object({
  customerName: z.string().trim().nonempty(),
  displayName: z.string().trim().nonempty(),
  barcoConfig: BarcoConfig,
  adminEmail: z.email().transform((email) => email.toLowerCase()),
  tenantConfig: TenantConfig.optional(),
});

export type TenantCreateBodyType = z.infer<typeof TenantCreateBody>;

export const TenantUpdateBody = z.object({
  customerName: z.string().trim().nonempty(),
  displayName: z.string().trim().nonempty(),
  barcoConfig: BarcoConfig,
  tenantConfig: TenantConfig.optional(),
});

export type TenantUpdateBodyType = z.infer<typeof TenantUpdateBody>;

export const TenantListResponse = z.array(TenantGetResponse);

export type TenantListType = z.infer<typeof TenantListResponse>;

export const TenantMetadataConfigCreateResponse = z.object({
  versionId: z.string().describe('new version of the metadata config that was uploaded'),
});
export type TenantMetadataConfigCreateResponseType = z.infer<typeof TenantMetadataConfigCreateResponse>;

export const TenantMetadataConfigCreateRequestBody = z.object({
  metadata: z.string().describe('The metadata config as a string'),
});
export type TenantMetadataConfigCreateRequestBodyType = z.infer<typeof TenantMetadataConfigCreateRequestBody>;
